import styled from 'styled-components';
import { useCallback, useContext } from 'react';

import { paradigmLightBlue } from '@paradigm/design-system/src/colors';

import { useDefaultAccountModalMethods } from '@paradigm/features/src/preferences/default-accounts/modal-context';
import {
  VENUES,
  VenueCode,
} from '@paradigm/features/src/preferences/default-accounts/types';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { DefaultAccountModalActionsCtx } from './AccountSelectionProvider';

interface Props {
  readonly venue: string;
  readonly className?: string;
}

export default function EditDefaultButton({ venue, className }: Props) {
  const modalActions = useContext(DefaultAccountModalActionsCtx);
  const modalActionsV2 = useDefaultAccountModalMethods();
  const trackAction = useTrackAction();

  const onOpenEditDefault = useCallback(() => {
    trackAction('edit default account');
    if (VENUES.includes(venue as VenueCode)) {
      modalActionsV2.open(venue);
    } else {
      modalActions.open();
    }
  }, [modalActions, modalActionsV2, venue, trackAction]);

  return (
    <Button
      className={className}
      data-testid="edit-default-account-button"
      onClick={onOpenEditDefault}
    >
      Edit Default
    </Button>
  );
}

const Button = styled.button.attrs({ type: 'button' })`
  color: ${paradigmLightBlue};
  background: none;
  border: 0;
  padding: 0;
  display: inline;
  line-height: 1.6;
  font-size: 13px;
`;
